<template>
    <b-form id="offer_submit" @submit="onSubmit">
      <div class="alert alert-info" role="alert" v-if="$currentUser.department == 'adkey'">
        <h5>Правила именования:</h5>
        <p>
          Вариант А - приложение рекла или веб оффер<br/>
          Name app [iOS/Android/Web/Nutra/SEO] Geo, например Liga Stavok [iOS] RU
        </p>
        <p>
          Вариант Б - оффер из ПП<br/>
          В самом конце обязательно указываем название партнёрки, например Vulkan [Android] CH – CPABRO
        </p>
        <p>
          Вариант В - наше приложение (заводится в CRM Полиной)<br/>
          [Название ПП] название оффера гео CPA/CPI ставка и валюта, например [Ultra Partners] VegasPlus CH CPA 125eur
        </p>
      </div>
        <div class="row">
            <div class="col-sm-12">
                <label>Аффайз ID</label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-11">
                <b-form-group>
                    <v-select :options="options" :filterable="false" v-model="form.affise_id" @search="onSearch">
                        <template slot="no-options">
                            Начните вводить ID...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.id }}
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.id }}
                            </div>
                        </template>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-sm-1 pt-2"
                 v-bind:style="[isMobile ? {'padding-left': '15px', 'padding-bottom': '10px', 'padding-top': '0px !important'} : {'padding-left': '0px'}]">
                <div style="cursor: pointer;"
                     align="center"
                     v-on:click="fillFields()">
                    <i class="icon-fa icon-fa-refresh"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Аффайз платформа">
                    <v-select :options="affisePlatforms" v-model="form.affise_platform">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && !form.affise_platform">Выберите Аффайз платформу.</span>
                </b-form-group>
                <b-form-group label="Название"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="form.title">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.title">Заполните название.</span>
                </b-form-group>
                <b-form-group label="Тип">
                    <v-select :options="types"
                              required
                              :searchable="false"
                              v-model="form.type">
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.type">Укажите тип.</span>
                </b-form-group>
                <b-form-group label="Гео">
                    <v-select :options="countries" required v-model="form.geo" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && form.geo.length === 0">Добавьте страну.</span>

                </b-form-group>
                <b-form-group label="Платформа">
                    <v-select :options="platforms" required v-model="form.platforms" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && form.platforms.length === 0">Добавьте платформу.</span>

                </b-form-group>
                <b-form-group v-if="$currentUser.department == 'agency'" label="Вертикаль">
                    <v-select :options="topics"
                              v-model="form.topic">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.topic">Заполните вертикаль.</span>
                </b-form-group>
                <b-form-group label="Рекламодатель">
                  <v-select :options="advertisers" :reduce="advertiser => advertiser.value" required v-model="form.advertiser_id">
                    <span slot="no-options">Совпадений не найдено.</span>
                  </v-select>
                  <span class=" alert-danger"
                        v-if="submitted && !form.advertiser_id">Выберите рекламодателя.</span>
                </b-form-group>
                <b-form-group label="Трекер">
                    <v-select :options="trackers"
                              v-model="form.tracker">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </b-form-group>
                <b-form-group label="Валюта оффера">
                    <v-select :options="currency" :searchable="false" required v-model="form.currency"></v-select>
                    <span class=" alert-danger" v-if="submitted && !form.currency">Добавьте валюту.</span>
                </b-form-group>

                <b-dropdown right variant="primary" split text="Сохранить и выйти" v-on:click="onSubmit($event, true)"
                            class="float-right">
                    <b-dropdown-item v-on:click="onSubmit($event, true)">Сохранить и выйти</b-dropdown-item>
                    <b-dropdown-item v-on:click="onSubmit($event, false)">Сохранить и создать</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService';
    import AdvertiserFormMixin from "../mixins/Advertiser/advertiserFormMixin";

    export default {
        name: 'CreateOfferModal',
        components: {
            OffersService: OffersService
        },

        mixins:[AdvertiserFormMixin],

        data() {
            return {
                form: {
                    title: null,
                    geo: [],
                    currency: null,
                    affise_platform: 'Zorka Network',
                    platforms: [],
                    tracker: null,
                    affise_id: null,
                    advertiser_id: null,
                    manager_id: null,
                    topic: null
                },
                countries: [],
                affisePlatforms: [],
                platforms: [],
                topics: [],
                types: [
                    {
                        label: 'Белый',
                        value: 'white'
                    },
                    {
                        label: 'Серый',
                        value: 'grey'
                    },
                    {
                      label: 'Seo',
                      value: 'seo'
                    },
                    {
                      label: 'InfoBiz',
                      value: 'infoBiz'
                    }
                ],
                trackers: [],
                currency: [],
                options: [],
                offer: null,
                submitted: false,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
            }
        },
        methods: {
            onSubmit(evt, close) {
                evt.preventDefault();
                this.submitted = true;

                if (!this.form.title || this.form.geo.length == 0 || this.form.platforms.length == 0 || !this.form.advertiser_id || !this.form.currency || !this.form.affise_platform || !this.form.type) {
                    evt.preventDefault();

                    return;
                }

                if (this.$currentUser.department === 'agency' && !this.form.topic) {
                    evt.preventDefault();

                    return;
                }

                this.form.affise_id = this.form.affise_id ? this.form.affise_id.id : null;

                OffersService.saveOffer(this.form)
                    .then(function (response) {
                        if (close && response) {
                            window.location.href = '/';
                        } else if (!close && response) {
                            this.form = {
                                title: null,
                                geo: [],
                                currency: null,
                                affise_platform: 'Zorka Network',
                                platforms: [],
                                tracker: null,
                                affise_id: null,
                                advertiser_id: null,
                                manager_id: null,
                                topic: null
                            };
                            this.submitted = false;
                        }
                    }.bind(this))
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                this.isMobile = this.window.width < 577;
            },
            getCountries() {
                OffersService.getCountries()
                    .then(function (response) {
                        let countries = [];

                        response.forEach(function (item) {
                            countries.push(item.code);
                        });

                        this.countries = countries;
                    }.bind(this))
            },
            getAffisePlatforms() {
                OffersService.getAffisePlatforms()
                    .then(function (response) {

                        this.affisePlatforms = response;
                    }.bind(this))
            },
            getPlatforms() {
                OffersService.getPlatforms()
                    .then(function (response) {

                        this.platforms = response;
                    }.bind(this))
            },
            getTrackers() {
                OffersService.getTrackers()
                    .then(function (response) {

                        this.trackers = response;
                    }.bind(this))
            },
            getTopics() {
                OffersService.getTopics()
                    .then(function (response) {

                        this.topics = response;
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            onSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);

                    let affisePlatform = this.form.affise_platform;

                    if (!affisePlatform) {
                        affisePlatform = 'Zorka Network';
                    }

                    OffersService.searchOffer(search, affisePlatform)
                        .then(function (response) {

                            if (response.offer) {
                                response.offer.label = response.offer.title
                                this.options = [response.offer]
                                this.offer = response.offer
                            }
                            loading(false);
                        }.bind(this), 350)
                }
            },
            fillFields() {
                if (this.offer) {
                    let countries = [];
                    let platforms = [];

                    this.offer.payments.forEach(function (item) {
                        countries = countries.concat(item.countries)
                        platforms = platforms.concat(item.os)
                    }.bind(this));

                    let uniqueCountries = [];

                    countries.forEach(function (el) {
                        if (uniqueCountries.indexOf(el) === -1) {
                            uniqueCountries.push(el)
                        }
                    });

                    let uniquePlatforms = [];

                    platforms.forEach(function (el) {
                        if (uniquePlatforms.indexOf(el) === -1 && this.platforms.indexOf(el) > -1) {
                            uniquePlatforms.push(el)
                        }
                    }.bind(this));

                    this.form.geo = uniqueCountries;
                    this.form.platforms = uniquePlatforms;
                }
            },

            //метод не используется MBR-253
            getAdvertiser(id) {
                let affisePlatform = this.form.affise_platform;

                if (!affisePlatform) {
                    affisePlatform = 'Zorka Network';
                }
                OffersService.getAdvertiser(id, affisePlatform)
                    .then(function (response) {
                        this.form.advertiser = response.advertiser.title;
                        this.form.manager_id = response.advertiser.manager_obj.id;

                    }.bind(this))
            }
        },
        watch: {
            'form.affise_id': function (newVal, oldVal) {
                if (newVal && newVal.id != oldVal) {
                    this.form.title = this.offer.title;
                }
            }
        },
        beforeMount() {
            this.getCountries();
            this.getCurrency();
            this.getTrackers();
            this.getPlatforms();
            this.getAffisePlatforms();
            this.getAdvertisers();

            if (this.$currentUser.department == 'agency') {
                this.getTopics();
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/CreateOfferModal.vue